import { useEffect, useRef, useState } from 'react';

import { getMerchantData } from 'api';
import { useMerchantId } from 'hooks';
import { Logger } from 'wtb-utils';

const useMerchantData = () => {
  const cache = useRef({});
  const status = useRef('EMPTY');

  const [ merchantData, setMerchantData ] = useState();

  const id = useMerchantId();

  useEffect(() => {
    if (!id || status.current === 'FETCHING') return;

    if (cache.current[id]) {
      setMerchantData(cache.current[id]);
    } else {
      status.current = 'FETCHING';

      getMerchantData(id)
        .then((data) => {
          cache.current[id] = data;
          setMerchantData(data);
          status.current = 'FETCHED';
        })
        .catch((error) => {
          Logger.error(error);

          alert('Error getting data');
        });
    }
  }, [ id ]);

  return merchantData;
};

export default useMerchantData;
